import { render, staticRenderFns } from "./BaseNotificationDropdown.vue?vue&type=template&id=aeb98ac8"
import script from "./BaseNotificationDropdown.vue?vue&type=script&lang=ts"
export * from "./BaseNotificationDropdown.vue?vue&type=script&lang=ts"
import style0 from "./BaseNotificationDropdown.vue?vue&type=style&index=0&id=aeb98ac8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports